import { translatableStringFactory } from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import type {
    AccommodationQuantityType} from "./accommodation-quantity-types";
import {
    accommodationQuantityTypes,
} from "./accommodation-quantity-types";

const accommodationQuantityIdPrefix = "accommodation_quantity_";
type AccommodationQuantityId =
    `${typeof accommodationQuantityIdPrefix}${Lowercase<AccommodationQuantityType>}__${string}`;
const accommodationQuantityIdFactory = (type: AccommodationQuantityType) => {
    return `${accommodationQuantityIdPrefix}${type.toLocaleLowerCase()}__${generateId(
        { prefix: "" },
    )}`;
};
const isAccommodationQuantityId = (
    id: string,
): id is AccommodationQuantityId => {
    return (
        id.startsWith(accommodationQuantityIdPrefix) &&
        accommodationQuantityTypes.some(type =>
            id
                .replace(accommodationQuantityIdPrefix, "")
                .startsWith(type.toLowerCase()),
        )
    );
};
const accommodationQuantityIdZodString = z.string().regex(
    new RegExp(
        `^${accommodationQuantityIdPrefix}(${accommodationQuantityTypes
            .join("|")
            .toLowerCase()}).*$`,
    ),
    translatableStringFactory({
        sv: "Ogiltigt id för boendeantal",
        en: "Invalid accommodation quantity id",
    }),
);

export {
    accommodationQuantityIdFactory,
    accommodationQuantityIdPrefix,
    accommodationQuantityIdZodString,
    isAccommodationQuantityId,
};
export type { AccommodationQuantityId };
